//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * mt-side-navbar
 * @module components/side-navbar
 * @desc 顶部 tab，依赖 tab-item
 *
 * @param {boolean} [fixed=false] - 固定底部
 * @param {*} selected - 返回 item component 传入的 value
 *
 * @example
 * <mt-side-navbar :selected.sync="selected">
 *   <div slot="nav">
 *     <mt-tab-item value="订单">
 *       <span slot="label">订单</span>
 *     </mt-tab-item>
 *   </div>
 * </mt-side-navbar>
 *
 * <mt-side-navbar :selected.sync="selected" fixed>
 *   <div slot="nav">
 *     <mt-tab-item :value="['传入数组', '也是可以的']">
 *       <span slot="label">订单</span>
 *     </mt-tab-item>
 *   </div>
 * </mt-side-navbar>
 *
 */
export default {
  name: 'mt-side-navbar',
  data(){
    return {
      marginLeft:"",
      sideNavbarHeight:""
    }
  },
  props: {
    fixed: {
      type: Boolean,
      default: true
    },
    value: {},
    width: {
      type: String,
      default: '108px'
    },
    top: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '0'
    }
  },
  mounted() {
    this.resetPosition();
  },
  methods: {
    resetPosition() {
      let elem = this.$el;
      let obj = {
        "top":elem.offsetTop
      };
      while(elem != document.body){
        elem = elem.offsetParent ;
        obj.top += elem.offsetTop ;
      }
      if(this.height === '0'){
        this.sideNavbarHeight = window.screen.height-obj.top;
        this.sideNavbarHeight = (this.sideNavbarHeight > elem.offsetHeight?elem.offsetHeight:this.sideNavbarHeight)+"px";
      }else{
        this.sideNavbarHeight = this.height;
      }
      if (this.fixed){
        this.marginLeft=this.width;
        if(this.top === ''){
          this.$el.querySelector('.navbar').style.top = obj.top + 'px';
        }else{
          this.$el.querySelector('.navbar').style.top = this.top;
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./packages/side-navbar/src/sideNavbar.vue